export type Contact = {
  contactId: string;
  title: string;
  lastName: string;
  firstName: string;
  function?: ContactFunction;
  email: string;
  phone: string;
};

export enum ContactFunction {
  coproprietaire = 'Copropriétaire',
  gardien = 'Gardien',
  proprietaire = 'Propriétaire',
  locataire = 'Locataire',
  personnelEntretien = "Personnel d'entretien",
  autre = 'Autre',
}
